export function loadHappygoProductMaster() {
  return {
    type: 'LOAD_HAPPYGO_PRODUCT_MASTER',
  };
}

export function loadHappygoProductMasterCompletion(error, list) {
  return {
    type: 'LOAD_HAPPYGO_PRODUCT_MASTER_COMPLETION',
    error,
    list,
  };
}

export function addHappygoProduct(code, price) {
  return {
    type: 'ADD_HAPPYGO_PRODUCT',
    code,
    price,
  };
}

export function deleteAllHappygoProduct() {
  return {
    type: 'DELETE_ALL_HAPPYGO_PRODUCT',
  };
}

export function deleteHappygoProduct(code, price) {
  return {
    type: 'DELETE_HAPPYGO_PRODUCT',
    code,
    price,
  };
}
